// extracted by mini-css-extract-plugin
module.exports = {"ellipsis-single":"Text_ellipsis-single__2SXBu","ellipsis-multiple":"Text_ellipsis-multiple__2v4No"};